(function () {
  function init(root) {
    if (root.dataset.compareBound) return;
    root.dataset.compareBound = 'true';
    var pairs = Array.from(root.querySelectorAll('[data-compare-pair]'));
    var choices = Array.from(root.querySelectorAll('[data-compare-choice]'));
    var steps = Array.from(root.querySelectorAll('[data-compare-step]'));
    var count = root.querySelector('[data-compare-count]');
    var status = root.querySelector('[data-compare-status]');
    var viewer = root.querySelector('[data-compare-viewer]');
    var error = root.querySelector('[data-compare-error]');
    var retry = root.querySelector('[data-compare-retry]');
    var target = 0, version = 0;
    function warm(index, retryLoad) {
      if (!pairs[index]) return Promise.resolve(false);
      return Promise.all(Array.from(pairs[index].querySelectorAll('img')).map(function (image) {
        image.loading = 'eager';
        if (retryLoad && image.complete && !image.naturalWidth) image.src = image.getAttribute('src');
        if (image.decode) return image.decode().then(function () { return true; }, function () { return false; });
        if (image.complete) return Promise.resolve(image.naturalWidth > 0);
        return new Promise(function (resolve) {
          image.addEventListener('load', function () { resolve(true); }, { once: true });
          image.addEventListener('error', function () { resolve(false); }, { once: true });
        });
      })).then(function (results) { return results.every(Boolean); });
    }
    function clearPending() {
      choices.forEach(function (choice) { choice.classList.remove('is-pending'); });
      if (viewer) viewer.removeAttribute('aria-busy');
    }
    function paint(index) {
      pairs.forEach(function (pair, i) { pair.hidden = i !== index; });
      choices.forEach(function (choice, i) {
        choice.classList.toggle('is-selected', i === index);
        choice.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      steps.forEach(function (button) { button.disabled = Number(button.dataset.compareStep) < 0 ? index === 0 : index === pairs.length - 1; });
      if (count) count.textContent = (index + 1) + ' / ' + pairs.length;
      if (status) status.textContent = 'Comparison ' + (index + 1) + ' of ' + pairs.length;
      clearPending();
      warm(index + 1);
    }
    function select(index) {
      target = Math.max(0, Math.min(pairs.length - 1, index));
      var request = ++version, selected = target;
      if (error) error.hidden = true;
      choices.forEach(function (choice, i) { choice.classList.toggle('is-pending', i === selected); });
      if (status) status.textContent = 'Loading comparison ' + (selected + 1) + ' of ' + pairs.length;
      if (viewer) viewer.setAttribute('aria-busy', 'true');
      warm(selected, true).then(function (loaded) {
        if (request !== version) return;
        if (loaded) paint(selected);
        else {
          clearPending();
          if (error) error.hidden = false;
          if (status) status.textContent = 'Could not load comparison ' + (selected + 1) + '. Try again.';
        }
      });
    }
    if (retry) retry.addEventListener('click', function () { select(target); });
    choices.forEach(function (choice, i) {
      choice.addEventListener('click', function () { select(i); });
      choice.addEventListener('pointerenter', function () { warm(i); });
      choice.addEventListener('focus', function () { warm(i); });
    });
    steps.forEach(function (button) {
      button.addEventListener('click', function () { select(target + Number(button.dataset.compareStep)); });
    });
    root.addEventListener('keydown', function (event) {
      if (!event.target.closest('[data-compare-choice],[data-compare-step]')) return;
      var next;
      if (event.key === 'ArrowLeft') next = target - 1;
      else if (event.key === 'ArrowRight') next = target + 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = pairs.length - 1;
      else return;
      event.preventDefault();
      select(next);
      if (event.target.hasAttribute('data-compare-choice')) choices[target].focus({ preventScroll: true });
    });
    var first = pairs[0] && pairs[0].querySelector('img');
    if (first) {
      if (first.complete) warm(1);
      else first.addEventListener('load', function () { warm(1); }, { once: true });
    }
  }
  document.querySelectorAll('[data-hp-compare]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-hp-compare]').forEach(init); });
})();
